export const products = [
  {
    id: 1,
    title: "iPhone",
    price: 549,
    discountPercentage: 12.96,
    rating: 4.69,
    stock: 94,
    thumbnail: require("../assets/images/products/iphone.jpg"),
  },
  {
    id: 7,
    title: "Google Pixel",
    price: 799,
    discountPercentage: 11.02,
    rating: 4.57,
    stock: 120,
    thumbnail: require("../assets/images/products/google.jpg"),
  },
  {
    id: 8,
    title: "Samsung",
    price: 1899,
    discountPercentage: 1.02,
    rating: 4.97,
    stock: 10,
    thumbnail: require("../assets/images/products/samsung.jpg"),
  },
  
  {
    id: 3,
    title: "Airpods",
    price: 1249,
    discountPercentage: 15.46,
    rating: 4.09,
    stock: 36,
    thumbnail: require("../assets/images/products/airpods.jpg"),
  },
  {
    id: 4,
    title: "Apple Watch",
    price: 280,
    discountPercentage: 17.91,
    rating: 4.3,
    stock: 0,
    thumbnail: require("../assets/images/products/smartwatch.jpg"),
  },
  {
    id: 5,
    title: "Charging Cable",
    price: 499,
    discountPercentage: 10.58,
    rating: 4.09,
    stock: 32,
    thumbnail: require("../assets/images/products/cable.jpg"),
  },
  {
    id: 6,
    title: "Headphones",
    price: 1749,
    discountPercentage: 11.02,
    rating: 4.57,
    stock: 83,
    thumbnail: require("../assets/images/products/headphones.jpg"),
  },
  {
    id: 2,
    title: "iPad",
    price: 899,
    discountPercentage: 17.94,
    rating: 4.44,
    stock: 34,
    thumbnail: require("../assets/images/products/ipad.jpg"),
  },
 
];
